import { render, staticRenderFns } from "./SellGoods.vue?vue&type=template&id=4a5db674&scoped=true&"
import script from "./SellGoods.vue?vue&type=script&lang=js&"
export * from "./SellGoods.vue?vue&type=script&lang=js&"
import style0 from "./SellGoods.vue?vue&type=style&index=0&id=4a5db674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5db674",
  null
  
)

export default component.exports